import React from "react";
import dog from "../Assets/notfound.gif";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import "./NotFound.css";
const NotFound = () => {
  return (
    <>
      <Header />
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <img src={dog} alt="dog" className="img-fluid" />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export { NotFound };
